import { forwardRef, useMemo } from "react";
import { useRouter } from "next/router";
import styles from "./Header.module.css";
import dynamic from "next/dynamic";
import { isIndianUser } from "@/utils/getCountryCode";
import HolidayHeaderSearch from "./HolidayHeaderSearch";
import ActivityHeaderSearch from "./ActivityHeaderSearch";
import ModuleNav from "../ModuleNav";
import { getActiveModuleTabId } from "../ModuleNav/moduleNavConfig";

const FlightSearchWidget = dynamic(
  () =>
    import("@travelswitchhq/flight-search-react").then(
      (mod) => mod.FlightSearchWidget
    ),
  { ssr: false }
);

const HotelSearchWidget = dynamic(
  () =>
    import("@travelswitchhq/hotel-search-react").then(
      (mod) => mod.HotelSearchWidget
    ),
  { ssr: false }
);

const Header = forwardRef(function Header(
  {
    backgroundImage,
    mobileBackgroundImage,
    hideNav
  },
  ref,
) {
  const router = useRouter();

  const activeTab = useMemo(
    () => getActiveModuleTabId(router.pathname),
    [router.pathname]
  );

  const heroStyle = useMemo(() => {
    const desktopImage = backgroundImage || mobileBackgroundImage;
    if (!desktopImage) return undefined;

    return {
      "--hero-bg-desktop": `url("${desktopImage}")`,
    };
  }, [backgroundImage, mobileBackgroundImage]);

  return (
    <section
      ref={ref}
      className={`${styles.hero} standard-padding ${backgroundImage || mobileBackgroundImage ? styles.heroDynamic : ""
        }`}
      style={heroStyle}
      aria-label="Hero"
      id="main-header"
    >
      <div className={styles.heroContainer}>
        <h1 className={styles.headline}>Your Journey, All in One Place</h1>
        <div className={styles.searchCard}>
          {hideNav ?
            null
            :
            <ModuleNav variant="header" />
          }
          {activeTab === "holidays" ? (
            <HolidayHeaderSearch />
          ) : activeTab === "stays" ? (
            <div className={styles.widgetWrap}>
              <HotelSearchWidget
                config={{
                  theme: {
                    primary: "#d92027",
                    secondary: "#FFFFFF",
                    primaryLight: "#FFEFEF",
                    secondaryBgText: "#121212",
                  },
                  redirectionDomain: isIndianUser()
                    ? "https://book.nextholidays.com/IN-EN"
                    : "https://book.nextholidays.com/AE-EN",
                  fontName: "Montserrat, Segoe UI, system-ui, sans-serif",
                  env: "prod",
                  productKey: "BCYC694T"
                }}
              />
            </div>
          ) : activeTab === "flights" ? (
            <div className={styles.widgetWrap}>
              <FlightSearchWidget
                config={{
                  theme: {
                    primary: "#d92027",
                    secondary: "#FFFFFF",
                    primaryLight: "#FFEFEF",
                    secondaryBgText: "#121212",
                  },
                  redirectionDomain: isIndianUser()
                    ? "https://book.nextholidays.com/IN-EN"
                    : "https://book.nextholidays.com/AE-EN",
                  fontName: "Montserrat, Segoe UI, system-ui, sans-serif",
                  env: "prod",
                  productKey: "BCYC694T"
                }}
              />
            </div>
          ) : activeTab === "activities" ? (
            <ActivityHeaderSearch />
          ) : null}
        </div>
      </div>
    </section>
  );
});

export default Header;
